import select2 from 'select2';
select2($);